import { MSDropdown } from '../../common/dropdown/index.js';
import { UiFloatModal } from '../../common/modal/index.js'
import { makeid } from '../../common/utils/idgen.js';
import styles from './kits.css'

const deleteSvg = `
    <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.857143 14.2222C0.857143 15.2 1.62857 16 2.57143 16H9.42857C10.3714 16 11.1429 15.2 11.1429 14.2222V3.55556H0.857143V14.2222ZM12 0.888889H9L8.14286 0H3.85714L3 0.888889H0V2.66667H12V0.888889Z" fill="black"/>
    </svg>
`

const selectElem = () => `
    <div class="tooltip-wrap">
        <select id="modal-select-upload" class="modal-select">
            <option value="" id="select-default">${i18next.t('trend_kits_no_sets_created')}</option>
        </select>
        <div class="tooltip">${i18next.t('trend_kits_renameTooltip')}</div>
    </div>
    <input id="modal-input-upload" class="modal-input-upload" type="text" />
`

const createOption = (value, id, selected) => `
    <option value="${id}" ${id === selected ? 'selected' : ''}>${value}</option>
`

const createTemplate = (value = '') => `
    <div class="create-window-wrap">
        <input id="modal-input-create" placeholder="${i18next.t('trend_kits_newKit')}" class="modal-input" value="${value}" />
    </div>
`

const templateModal = (template) => `<style>
   ${styles}
    </style>
    <div class="modal-template-wrap">
        <div class="modal-content-wrap" id="modal-content-wrap">
            ${template}
        </div>
        <div class="modal-controls">
            <div class="modal-control-btn" id="modal-control-btn-ok">${i18next.t('trend_kits_modal_save')}</div>
            <div class="modal-control-btn" id="modal-control-btn-close">${i18next.t('trend_kits_modal_cancel')}</div>
        </div>
    </div>
`

const uploadTemplate = () => `
    <div class="create-window-wrap">
        <div class="upload-wrap">
           <div class="select-wrap" id="select-wrap">${selectElem()}</div>
            <div class="btn-icon-del" id="btn-icon-del">
                <div class="tooltip-wrap">
                    ${deleteSvg}
                    <div class="tooltip">${i18next.t('trend_kits_deleteSelectedKit')}</div>
                </div>
            </div>
        </div>
        <div id="upload-error-wrap"></div>
    </div>
`

const deleteTemplate = `
    <div class="create-window-wrap">
        <p id="delete-text"></p>
    </div>
`

const existAlert = (value) => `
    <div class="modal-exist-wrap">
        <p>${i18next.t('trend_kits_existAlert1')} <span class="modal-group-name">${value}</span> ${i18next.t('trend_kits_existAlert2')}</p>
    </div>
`

const template = `
    <style>
        ${styles}
    </style>
    <div id="trend-groups">
        <ui-dropdown value="" id="group-tool" border="-10">
            <div slot="label" id="group-dropdown-label" class="group-dropdown-label">
                <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.09687 17.25L5.51875 11.1031L0.75 6.96875L7.05 6.42188L9.5 0.625L11.95 6.42188L18.25 6.96875L13.4812 11.1031L14.9031 17.25L9.5 13.9906L4.09687 17.25Z"/>
                </svg>
            </div>
        </ui-dropdown>
    </div>
`

const uploadError = () => `
    <span class="error-upload">${i18next.t('trend_kits_errorUpload')}</span>
`

const values = () => {
    return [
        { id: 'create', active: true, value: '', component: `${i18next.t('trend_kits_saveKit')}` },
        { id: 'upload', active: true, value: '', component: `${i18next.t('trend_kits_choseKit')}` },
        { id: 'clear', active: true, value: '', component: `${i18next.t('trend_kits_reset')}` },
    ]
}

/**
 * @class TrendKits
 * @classdesc ������ ������
 * */
export class TrendKits {
    constructor(root, container) {
        this.state = {
            createValue: '',
            updateValue: '',
            groups: [],
            activeGroup: null,
            temporaryGroup: null,
            editMode: false,
            deleteMode: false,
            uploadError: false,
            disabled: true,
        }
        this.root = root
        this.container = container
        this.container.innerHTML = template
        this.initDropDown()
    }

    initDropDown() {
        this.root.checkComponent('ui-dropdown', MSDropdown)
        this.dropdown = this.container.querySelector('#group-tool')
        this.dropdown.cssElem.innerHTML += styles
        this.dropdown.childrens.style.width = 'max-content'
        this.dropdown.childrens.style.zIndex = 100
        this.dropdown.values = values()
        this.dropdown.onClick = this.dispatchAction.bind(this)
        this.dropdown.createList()
    }

    dispatchAction(e) {
        const li = e.target.closest('li')
        const Id = li?.getAttribute('Id')
        if (!li || !Id) return
        if (Id === 'create') this.createAction()
        if (Id === 'upload') this.uploadAction()
        if (Id === 'clear') this.clearAction()
    }

    createAction() {
        if (!this.createWindow) {
            this.createWindow = new UiFloatModal(templateModal(createTemplate(this.state.createValue)))
            this.input = this.createWindow.modalComponent.querySelector('#modal-input-create')
            this.input.addEventListener('keyup', this.onInput.bind(this))
            this.createWindow.modalComponent.querySelector('#modal-control-btn-ok').addEventListener('click', this.onCreateOkClick.bind(this))
            this.createWindow.modalComponent.querySelector('#modal-control-btn-close').addEventListener('click', this.onCreateCloseClick.bind(this))
            this.createWindow.modalComponent.dropdown = this.dropdown
            if(!this.root.parentHasPopup) this.createWindow.root.style.zIndex = 10000100
            this.createWindow.modalComponent.calculateInitialPosition = () => {
                const { top, left } = this.dropdown.rootElem.getBoundingClientRect()
                // 20 - это дополнительный отступ, чтобы не прилипало к верху
                return [left, top + 20]
            }
            this.createWindow.modalComponent.label = i18next.t('trend_kits_saveKit')
        }
        this.input.value = this.state.createValue
        this.createWindow.modalComponent.toggle()
    }

    onInput(e) {
        this.state.createValue = e.target.value
    }

    onCreateOkClick() {
        if (!this.state.createValue) return
        const storedState = this.root.getItemState(this.root.originPath, this.root.windowId);
        const pens = Array.isArray(storedState.penStates) && storedState.penStates.length ? storedState.penStates : this.root.pens
        const sources = pens.map((e) => ({ id: e.source, title: e.title || e.name, color: e.color }))
        const groupExist = this.state.groups.find(g => g.name === this.state.createValue)
        if (groupExist) {
            this.temporaryGroup = groupExist.id
            this.groupExist()
        }
        else {
            const group = { id: makeid(10), name: this.state.createValue, sources }
            this.state.groups.push(group)
            this.activeGroup = group.id
            this.onUpload()
        }
        this.state.createValue = ''
        this.createWindow.modalComponent.toggle()
    }

    onCreateCloseClick() {
        this.state.createValue = ''
        this.createWindow.modalComponent.toggle()
    }

    createUploadWindow() {
        if (this.uploadWindow) return
        this.uploadWindow = new UiFloatModal(templateModal(uploadTemplate()))
        if(!this.root.parentHasPopup) this.uploadWindow.root.style.zIndex = 10000100
        this.changeInput = this.uploadWindow.modalComponent.querySelector('#modal-input-upload')
        this.selectWrap = this.uploadWindow.modalComponent.querySelector('#select-wrap')
        this.select = this.uploadWindow.modalComponent.querySelector('#modal-select-upload')
        this.uploadErrorWrap = this.uploadWindow.modalComponent.querySelector('#upload-error-wrap')
        this.deleteBtn = this.uploadWindow.modalComponent.querySelector('#btn-icon-del')
        this.changeInput.addEventListener('change', (e) => {
            this.state.updateValue = e.target.value
        })
        this.select.addEventListener('change', this.onSelect.bind(this))
        this.selectWrap.addEventListener('dblclick', () => this.editMode = !this.editMode)
        this.deleteBtn.addEventListener('click', this.onDelete.bind(this))
        this.uploadWindow.modalComponent.querySelector('#btn-icon-del')
        this.uploadWindow.okBtn = this.uploadWindow.modalComponent.querySelector('#modal-control-btn-ok')
        this.uploadWindow.closeBtn = this.uploadWindow.modalComponent.querySelector('#modal-control-btn-close')
        this.uploadWindow.okBtn.innerHTML = i18next.t('apply')
        this.uploadWindow.okBtn.addEventListener('click', this.onUploadOkClick.bind(this))
        this.uploadWindow.closeBtn.addEventListener('click', this.onUploadCloseClick.bind(this))

        this.uploadWindow.modalComponent.dropdown = this.dropdown
        this.uploadWindow.modalComponent.calculateInitialPosition = () => {
            const { top, left } = this.dropdown.rootElem.getBoundingClientRect()
            // 20 - это дополнительный отступ, чтобы не прилипало к верху
            return [left, top + 20]
        }
        this.uploadWindow.modalComponent.label = i18next.t('trend_kits_uploadKit')
    }

    uploadAction() {
        this.createUploadWindow()
        this.createDeleteWindow()
        if (this.activeGroup !== this.temporaryGroup) this.temporaryGroup = this.activeGroup
        this.generateOptions()  
        this.uploadWindow.modalComponent.toggle()
    }

    generateOptions() {
        if (!this.select) return
        this.select.innerHTML = selectElem()
        if (this.state.groups.length) this.disabled = false
        else this.disabled = true
        for (let i = 0; i < this.state.groups.length; i++) {
            const elem = this.state.groups[i]
            const option = createOption(elem.name, elem.id, this.temporaryGroup)
            this.select.innerHTML += option
        }
    }

    onSelect(e) {
        this.temporaryGroup = e.target.value
    }

    createDeleteWindow() {
        if (this.deleteWindow) return
        this.deleteWindow = new UiFloatModal(templateModal(deleteTemplate))
        this.deleteLabel = this.deleteWindow.modalComponent.querySelector('#delete-text')
        this.deleteWindow.okBtn = this.deleteWindow.modalComponent.querySelector('#modal-control-btn-ok')
        this.deleteWindow.closeBtn = this.deleteWindow.modalComponent.querySelector('#modal-control-btn-close')
        this.deleteWindow.okBtn.innerHTML = i18next.t('delete')
        this.deleteWindow.okBtn.addEventListener('click', this.onDeleteConfirm.bind(this))
        this.deleteWindow.closeBtn.addEventListener('click', this.onDeleteCancel.bind(this))

        this.deleteWindow.modalComponent.dropdown = this.dropdown
        if(!this.root.parentHasPopup) this.deleteWindow.root.style.zIndex = 10000100
        this.deleteWindow.modalComponent.calculateInitialPosition = () => {
            const { top, left } = this.dropdown.rootElem.getBoundingClientRect()
            // 20 - это дополнительный отступ, чтобы не прилипало к верху
            return [left, top + 20]
        }
    }

    onDeleteConfirm() {
        this.deleteMode = false
        this.state.groups = this.state.groups.filter(g => g.id !== this.temporaryGroup)
        if (this.uploadError) this.uploadError = false
        if (this.editMode) this.editMode = false
        this.activeGroup = null
        this.generateOptions()
        this.root.saveKitsState()
    }

    onDeleteCancel() {
        this.deleteMode = false
    }

    onDelete() {
        if (!this.temporaryGroup || this.editMode) return
        this.deleteMode = true

    }

    onUploadOkClick() {
        if (this.disabled) return
        if (this.editMode) this.onUploadEditMode()
        else {
            this.onUpload()
            this.uploadWindow.modalComponent.toggle()
        }
    }
    
    closeAllWindow(){
        if(this.createWindow) this.createWindow.modalComponent.close();
        if(this.uploadWindow) this.uploadWindow.modalComponent.close();
        if(this.deleteWindow) this.deleteWindow.modalComponent.close();
        if(this.groupExistWindow) this.groupExistWindow.modalComponent.close();
    }

    onUploadEditMode() {
        const groupExist = this.state.groups.find(g => g.name === this.uploadValue)
        if (groupExist?.id === this.temporaryGroup) return this.editMode = false
        if (groupExist) this.uploadError = true
        else {
            const group = this.state.groups.find((g) => g.id === this.temporaryGroup)
            group.name = this.uploadValue
            this.editMode = false
        }
    }

    onUpload() {
        const group = this.state.groups.find((g) => g.id === this.temporaryGroup)
        if (!group) return
        const sources = group?.sources
        this.activeGroup = this.temporaryGroup
        this.root.reCreatePens(sources)
        this.root.saveKitsState()
    }

    onUploadCloseClick() {
        if (this.editMode) {
            this.editMode = false
            this.uploadError = false
        }
        else this.uploadWindow.modalComponent.toggle()
    }

    groupExist() {
        const template = existAlert(this.state.createValue)
        if (!this.groupExistWindow) {
            this.groupExistWindow = new UiFloatModal(templateModal(template))
            if(!this.root.parentHasPopup) this.groupExistWindow.root.style.zIndex = 10000100
            this.groupExistWindow.okBtn = this.groupExistWindow.modalComponent.querySelector('#modal-control-btn-ok')
            this.groupExistWindow.closeBtn = this.groupExistWindow.modalComponent.querySelector('#modal-control-btn-close')
            this.groupExistWindow.okBtn.innerHTML = 'Ok'
            this.groupExistWindow.okBtn.addEventListener('click', this.onExistOkClick.bind(this))
            this.groupExistWindow.closeBtn.addEventListener('click', this.onExistCloseClick.bind(this))
            this.groupExistWindow.modalComponent.wrap = this.groupExistWindow.modalComponent.querySelector('#modal-content-wrap')

            this.groupExistWindow.modalComponent.dropdown = this.dropdown
            
            this.groupExistWindow.modalComponent.calculateInitialPosition = () => {
                const { top, left } = this.dropdown.rootElem.getBoundingClientRect()
                // 20 - это дополнительный отступ, чтобы не прилипало к верху
                return [left, top + 20]
            }
        }
        this.groupExistWindow.modalComponent.wrap.innerHTML = template
        this.groupExistWindow.modalComponent.toggle()
    }

    onExistOkClick() {
        const group = this.state.groups.find((g) => g.id === this.temporaryGroup)
        if (!group) return
        const storedState = this.root.getItemState(this.root.originPath, this.root.windowId);
        const pens = Array.isArray(storedState.penStates) && storedState.penStates.length ? storedState.penStates : this.root.pens
        group.sources = pens.map((e) => ({ id: e.source, title: e.title || e.name }))
        this.root.reCreatePens(group.sources)
        this.root.saveKitsState()
        this.groupExistWindow.modalComponent.toggle()
    }

    onExistCloseClick() {
        this.groupExistWindow.modalComponent.toggle()
    }

    clearAction() {
        this.root.ClearOptions()
    }

    setLegend(groupName = "") {
        const label = groupName ? `${i18next.t('trend_legend_titleMinilegend')} - ${groupName}` : i18next.t('trend_legend_titleMinilegend')
        if (this.root?.legend?.popup) this.root.legend.popup.title = label
    }

    get deleteMode() {
        return this.state.deleteMode
    }

    set deleteMode(v) {
        this.state.deleteMode = v
        const group = this.state.groups.find((g) => g.id === this.temporaryGroup)
        if (v) this.deleteLabel.textContent = `${i18next.t('trend_kits_want_delete_set')} ${group.name}`
        this.uploadWindow.modalComponent.toggle()
        this.deleteWindow.modalComponent.toggle()
    }

    get disabled() {
        return this.state.disabled
    }

    set disabled(v) {
        this.state.disabled = v
        const defaultOption = this.select.querySelector('#select-default')
        if (v) {
            defaultOption.style.display = 'block'
            defaultOption.textContent = i18next.t('trend_kits_KitNoCreate')
            this.select.setAttribute('disabled', true)
            this.uploadWindow.okBtn.classList.add('disabled')
        } else {
            defaultOption.style.display = 'none'
            defaultOption.textContent = i18next.t('trend_kits_select_set')
            this.select.removeAttribute("disabled")
            this.uploadWindow.okBtn.classList.remove('disabled')
        }
    }

    get activeGroup() {
        return this.state.activeGroup
    }

    set activeGroup(v) {
        this.state.activeGroup = v
        this.temporaryGroup = v
        const name = this.group?.name
        this.setLegend(name)
    }

    get editMode() {
        return this.state.editMode
    }

    set editMode(v) {
        if (!this.changeInput || !this.select || !this.temporaryGroup) return
        this.state.editMode = v
        if (v) {
            const group = this.state.groups.find((g) => g.id === this.temporaryGroup)
            this.changeInput.style.display = 'block'
            this.select.style.display = 'none'
            this.uploadValue = group.name
            this.uploadWindow.okBtn.innerHTML = i18next.t('confirm')
        } else {
            this.uploadError = false
            this.changeInput.style.display = 'none'
            this.select.style.display = 'block'
            this.uploadWindow.okBtn.innerHTML = i18next.t('ok')
            this.generateOptions()
        }

    }

    get temporaryGroup() {
        return this.state.temporaryGroup
    }

    set temporaryGroup(v) {
        this.state.temporaryGroup = v
    }

    get group() {
        const group = this.state.groups.find((g) => g.id === this.activeGroup)
        return group
    }

    set group(v) {

    }

    get uploadValue() {
        return this.state.updateValue
    }

    set uploadValue(v) {
        this.state.updateValue = v
        if (!this.changeInput) return
        this.changeInput.value = v
    }

    get uploadError() {
        return this.state.uploadError
    }

    set uploadError(v) {
        this.state.uploadError = v
        if (!this.uploadErrorWrap) return
        if (v) this.uploadErrorWrap.innerHTML = uploadError()
        else this.uploadErrorWrap.innerHTML = ''
    }
}
